<!-- @veltra/icons generated sha256:cc5a4e6f7a0adaea gen:8 source:src/svg/normal/sun.svg -->
<script setup lang="ts">
defineOptions({ name: 'Sun' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.333"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="4" />
    <path
      d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32 1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"
    />
  </svg>
</template>
